module.exports = __webpack_public_path__ + "media/boxes/open-box-with-pouches-87c66cdf.svg";